import styled from 'styled-components';
import { Icon } from '../../../../components/common/icon/Icon';
import { useCheckUserLoggedIn } from '../../../../hooks/user/useCheckUserLoggedIn';

interface IProductImageOverProps {
  onClick: () => void;
  disableLoginPrompt?: boolean;
}

export const ProductImageOverlay = ({ onClick, disableLoginPrompt = false }: IProductImageOverProps) => {
  const { isUserLoggedIn } = useCheckUserLoggedIn();

  return (
    <>
      {isUserLoggedIn && <OverlayForLoggedInUser />}
      {!isUserLoggedIn && !disableLoginPrompt && <OverlayForAnonymous onClick={onClick} />}
    </>
  );
};

interface IOverlayForAnonymous {
  onClick: () => void;
}

const OverlayForAnonymous = ({ onClick }: IOverlayForAnonymous) => {
  return (
    <AnonymousContainer onClick={onClick}>
      <AnonymousTitle>{'지금 로그인하고\n매물 사진과 가격 확인하기'}</AnonymousTitle>
      <KakaoLoginButton>
        <KakaoIconWrapper>
          <Icon name={'KakaoTalk'} width={24} height={24} />
        </KakaoIconWrapper>
        <KakakoLoginText>{'카카오로 3초만에 로그인'}</KakakoLoginText>
      </KakaoLoginButton>
    </AnonymousContainer>
  );
};

const OverlayForLoggedInUser = () => {
  return (
    <LoggedInUserConatiner>
      <Icon name={'PluvaMarketLogo'} width={105} height={14} />
    </LoggedInUserConatiner>
  );
};

const Container = styled.div`
  position: absolute;
  top: 0px;
  left: 0px;

  z-index: 5;
`;

const AnonymousContainer = styled(Container)`
  width: 100%;
  height: 100%;

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 24px;
  align-self: stretch;

  background: rgba(255, 255, 255, 0.9);
`;

const AnonymousTitle = styled.pre`
  color: var(--Light-Scheme-Monochrome-black, #232429);
  text-align: center;

  /* Display/XX-Large/xxl-bold */
  font-family: Pretendard;
  font-size: 20px;
  font-style: normal;
  font-weight: 700;
  line-height: 130%; /* 26px */
`;

const KakaoLoginButton = styled.div`
  width: 250px;
  height: 40px;

  display: flex;
  justify-content: center;
  align-items: center;

  padding: 16px 8px;

  gap: 10px;

  position: relative;

  border-radius: var(--radius-medium, 8px);
  background: #ffd337;
`;

const KakaoIconWrapper = styled.div`
  position: absolute;
  left: 8px;
  top: 8px;
`;

const KakakoLoginText = styled.span`
  color: var(--Light-Scheme-Monochrome-black, #232429);
  text-align: center;

  /* Display/Large/l-medium */
  font-family: Pretendard;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 130%; /* 20.8px */
`;

const LoggedInUserConatiner = styled(Container)`
  /* 로고 SVG가 잘리지 않도록 viewBox에 1px 여백을 넣었으므로, 그만큼 빼야 실제 로고가 디자인대로 16px 위치에 놓인다 */
  margin: 15px;

  opacity: 0.3;

  pointer-events: none;
`;
